<template>
  <div>
    <router-view></router-view>
    <notifications position="bottom right" />
  </div>
</template>
<script>
import * as authService from './service/auth'
import './style.scss'

export default {
  name: 'App',
  mounted () {
    this.checkAuth()
  },
  watch: {
    $route() {
      console.log('route changed')
      this.checkAuth()
    }
  },
  methods: {
    async checkAuth () {
      try {
        if (
          !(
            window.location.pathname.startsWith("/login") ||
            window.location.pathname.startsWith("/register") ||
            window.location.pathname.startsWith("/email-verification") ||
            window.location.pathname.startsWith("/reset-password") ||
            window.location.pathname.startsWith("/forgot-password") ||
            window.location.pathname.startsWith("/confirm-forgot-password")
          )
        ) {
          const user = await authService.verifyToken();
          if (
            window.location.pathname.startsWith("/site-permission") &&
            !user.is_super_admin
          ) {
            console.log("err: not super admin");
            window.location.href = "/";
          }
        }
      } catch (err) {
        console.log('err: ', err);
        window.location.href = '/login'
      }
    }
  }
}
</script>
